import { QuestionType } from "app/shared/models/question-type";
var FlaggedCondition = /** @class */ (function () {
    function FlaggedCondition() {
        this.flagDirection = null;
        this.clearFlagValues();
    }
    FlaggedCondition.prototype.clearFlagValues = function () {
        this._flagValues = [];
    };
    FlaggedCondition.prototype.addFlagValue = function (lbl) {
        var index = this._flagValues.findIndex(function (fl) { return fl.id == lbl.id; });
        if (index !== -1) {
            this._flagValues[index] = lbl;
        }
        this._flagValues.push(lbl);
    };
    FlaggedCondition.prototype.removeFlagValue = function (lbl) {
        this._flagValues = this._flagValues.filter(function (fl) { return fl.id != lbl.id; });
    };
    Object.defineProperty(FlaggedCondition.prototype, "flagValues", {
        get: function () {
            return this._flagValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlaggedCondition.prototype, "flagDirection", {
        get: function () {
            return this._flagDirection;
        },
        set: function (v) {
            this._flagDirection = v;
        },
        enumerable: true,
        configurable: true
    });
    FlaggedCondition.prototype.shouldFlagQuestion = function (question, questionSet) {
        if (!question.hasAnswer) {
            return false;
        }
        if (question.type == QuestionType.Textbox
            || question.type == QuestionType.SingleChoice) {
            return true;
        }
        var lbls = questionSet.labels;
        if (question.type == QuestionType.MultipleChoice) {
            var mcQuestion_1 = question;
            // there is only one with multiple choice questions
            var flagValue_1 = this._flagValues[0];
            var index = lbls.findIndex(function (l) { return l.id == flagValue_1.id; });
            var answerIndex = lbls.findIndex(function (l) { return l.id == mcQuestion_1.answer.id; });
            if (this.flagDirection == 'greaterOrEqual') {
                return answerIndex >= index;
            }
            else {
                return answerIndex <= index;
            }
        }
        if (question.type == QuestionType.Checklist) {
            var clQuestion = question;
            var answers_1 = clQuestion.answerForSave;
            var flagAnswer = lbls.some(function (l) { return answers_1[l.id]; });
            return flagAnswer;
        }
        return false;
    };
    return FlaggedCondition;
}());
export { FlaggedCondition };



// WEBPACK FOOTER //
// ./src/app/shared/models/flagged-condition.ts.pre-build-optimizer.js